import styled from 'styled-components';

export const Title = styled.span`
  font-size: 18px;
  color: #012349;
  font-weight: 700;
`;


export const PrimaryText = styled.span<{ size: number }>`
  color: #67BAAF;
  font-size: ${p => (p.size ? p.size : 14)}px;
`;
